<div class="ple-search-holder">
    <mat-icon class="wc-right">search</mat-icon>
    <input type="text" matInput placeholder={{question}} class="ple-left" [(ngModel)]="searchText" (keyup)="callSearchFieldEventEmitter()">
</div>